module.exports = __webpack_public_path__ + "assets/img/2806.a6f53bd9.png";